import { render, staticRenderFns } from "./logoDisposition.vue?vue&type=template&id=0c9c199c&"
import script from "./logoDisposition.vue?vue&type=script&lang=js&"
export * from "./logoDisposition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c9c199c')) {
      api.createRecord('0c9c199c', component.options)
    } else {
      api.reload('0c9c199c', component.options)
    }
    module.hot.accept("./logoDisposition.vue?vue&type=template&id=0c9c199c&", function () {
      api.rerender('0c9c199c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/indexDisposition/logoDisposition.vue"
export default component.exports